import {Auth} from 'aws-amplify'
import axios from 'axios'

export default {
  mounted() {},
  methods: {
    async createStudio() {
      try {
        const result = await axios.post(
          process.env.VUE_APP_API_ENDPOINT + '/viewer/studios',
          null,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async getStudioById(studioId) {
      try {
        const result = await axios.get(
          process.env.VUE_APP_API_ENDPOINT + '/viewer/studios/' + studioId,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result.data
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    // summary: Returns a thumbnail image (PNG format) by ID
    async getStudioThumbnailById(studioId) {
      try {
        const thumbnail = await axios.get(
          process.env.VUE_APP_API_ENDPOINT +
            '/viewer/studios/thumbnail/' +
            studioId,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return `data:${thumbnail.headers[
          'content-type'
        ].toLowerCase()};base64,${thumbnail.data.Data}`
      } catch (error) {
        // Do nothing because this error isn't critical.
        return false
      }
    },
    // summary: Post a thumbnail image (JPG/PNG format) by ID
    async setStudioThumbnailById(studioId, file) {
      try {
        const image = await this.getBase64(file)
        const result = await axios.post(
          process.env.VUE_APP_API_ENDPOINT +
            '/viewer/studios/thumbnail/' +
            studioId,
          {
            // Parameter "Format" is for future use. Do not use at the moment.
            // Format: "png",
            Data: image,
          },
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async getStudios(type) {
      let items = []
      const LIMIT = 500
      const params = {
        limit: LIMIT,
      }
      if (type === 'archives') {
        params.archived = true
      }
      if (type === 'share') {
        params.shared = true
      }
      if (type === 'public') {
        params.public = true
      }
      try {
        let offset = 0
        while (true) {
          params.offset = offset
          const result = await axios.get(
            process.env.VUE_APP_API_ENDPOINT + '/viewer/studios',
            {
              headers: {
                Authorization: (await Auth.currentSession()).getIdToken()
                  .jwtToken,
              },
              params: params,
            }
          )
          items = items.concat(result.data.Items)
          if (result.data.Items.length >= LIMIT) {
            offset += LIMIT
          } else {
            break
          }
        }
        return items
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async patchStudio(studioId, attributeName, attributeValue) {
      try {
        const result = await axios.patch(
          process.env.VUE_APP_API_ENDPOINT + '/viewer/studios/' + studioId,
          {
            [attributeName]: attributeValue,
          },
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async patchPointCloudOfStudio(studioId, index, attributes) {
      try {
        const result = await axios.patch(
          process.env.VUE_APP_API_ENDPOINT +
            `/viewer/studios/${studioId}/point_clouds`,
          attributes,
          {
            params: {
              index: index,
            },
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async deleteStudio(studioId, restore = false) {
      try {
        const result = await axios.delete(
          process.env.VUE_APP_API_ENDPOINT + '/viewer/studios/' + studioId,
          {
            params: {
              restore: restore,
            },
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async deletePointCloudOfStudio(studioId, index) {
      try {
        const result = await axios.delete(
          process.env.VUE_APP_API_ENDPOINT +
            `/viewer/studios/${studioId}/point_clouds`,
          {
            params: {
              index: index,
            },
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async getSharedOfStudio(studioId) {
      try {
        const result = await axios.get(
          process.env.VUE_APP_API_ENDPOINT +
            '/viewer/studios/share/' +
            studioId,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async postShareOfStudio(studioId, param) {
      try {
        const result = await axios.post(
          process.env.VUE_APP_API_ENDPOINT +
            '/viewer/studios/share/' +
            studioId,
          param,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        // This error is handled by parent function.
        throw error
      }
    },
    async postPublishOfStudioV2(studioId) {
      try {
        const result = await axios.post(
          process.env.VUE_APP_API_ENDPOINT +
            `/viewer/studios/public/${studioId}`,
          null,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async deleteShareOfStudio(studioId, email) {
      try {
        const result = await axios.delete(
          process.env.VUE_APP_API_ENDPOINT +
            '/viewer/studios/share/' +
            studioId,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
            params: {
              email: email,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async studiosViewer(studioId) {
      try {
        const result = await axios.get(
          process.env.VUE_APP_API_ENDPOINT +
            '/viewer/studios/launch/' +
            studioId,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        // Parent function handles this error.
        throw error
      }
    },
  },
}
